import { render, staticRenderFns } from "./Releves.vue?vue&type=template&id=71d3fb42&scoped=true&"
import script from "./Releves.vue?vue&type=script&lang=js&"
export * from "./Releves.vue?vue&type=script&lang=js&"
import style0 from "./Releves.vue?vue&type=style&index=0&id=71d3fb42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d3fb42",
  null
  
)

export default component.exports